import React from 'react';
import cx from 'classnames';

import Loader from 'ui-brand/components/Loader';

type Props = {
  variant?: 'primary' | 'outline' | 'secondary';
  size?: 'lg' | 'md' | 'sm';
  fullWidth?: boolean;
  arrow?: boolean;
  disabled?: boolean;
  loading?: boolean;
  type?: 'button' | 'submit';
  onClick?: () => void;
  children: React.ReactNode;
  className?: string;
};

function Button({
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  arrow = false,
  disabled = false,
  loading = false,
  type = 'button',
  onClick,
  children,
  className,
}: Props) {
  return (
    <button
      // eslint-disable-next-line react/button-has-type
      type={type}
      disabled={disabled || loading}
      onClick={onClick}
      className={cx(
        'inline-flex items-center justify-center gap-2 rounded-full font-lexend font-semibold leading-snug transition-opacity focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-retino-darkviolet',
        {
          'bg-retino-lightviolet text-retino-darkviolet hover:opacity-90': variant === 'primary',
          'border-[1.5px] border-retino-darkviolet bg-transparent text-retino-darkviolet hover:bg-retino-darkviolet/10':
            variant === 'outline',
          'text-retino-darkviolet/70 hover:text-retino-darkviolet': variant === 'secondary',
          'px-6 py-4 text-xl': size === 'lg',
          'px-6 py-2 text-lg': size === 'md',
          'px-4 py-2 text-base': size === 'sm',
          'w-full': fullWidth,
          'cursor-not-allowed opacity-40 hover:opacity-40': disabled,
        },
        className,
      )}
    >
      {loading ? <Loader size="sm" /> : <span className="contents">{children}</span>}
      {arrow && (
        <svg className="size-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M5 12h14M13 6l6 6-6 6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )}
    </button>
  );
}

export default Button;
